import { defineStore } from 'pinia'
import api from '../api'
import router from '../router'
import { syncUserKeys, applyKeySyncToStorage } from '@/utils/keySync'
import { resolveProfileUserId } from '@/utils/resolveProfileUserId'
import { clearLocalStoragePreservingGuideSeen } from '@/utils/productGuideStorage'
import { canUseProduct } from '@/utils/productAccess.js'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isAuth: !!localStorage.getItem('access'),
    access: localStorage.getItem('access')
  }),
  actions: {
    async login(identifier, password) {
      const payload = identifier.includes("@")
          ? { email: identifier, password }
          : { login: identifier, password };

      try {
        const { data } = await api.post("/token/", payload);
        localStorage.setItem("access",  data.access);
        localStorage.setItem("refresh", data.refresh);
        this.access = data.access;
        this.isAuth = true;
        await this.fetchProfile();
        try {
          const syncResult = await syncUserKeys(api)
          const userId = resolveProfileUserId(this.user)
          applyKeySyncToStorage(userId, syncResult)
        } catch (syncErr) {
          console.warn('[auth] keys sync after login failed', syncErr)
        }
        router.replace(canUseProduct(this.user) ? '/search' : '/account')
      } catch (e) {
        const rawDetail = (e?.response?.data?.detail || "").toString();
        const detail = rawDetail.toLowerCase();
        const code = (e?.response?.data?.code || "").toString();
        if (code === "email_not_verified" || detail.includes("подтвердите e-mail")) {
          e.isEmailNotVerified = true;
          e.userMessage = rawDetail;
        } else if (detail.includes("no active account") || detail.includes("inactive") || detail.includes("заблокирован")) {
          e.isInactiveAccount = true;
        }
        throw e;
      }
    },
    logout() {
      clearLocalStoragePreservingGuideSeen()
      this.user = null
      this.isAuth = false
      this.access = null
      router.push('/login')
    },
    async fetchProfile() {
      if (!this.isAuth) return
      const { data } = await api.get('/profile/')
      this.user = data
    },
    async updateProfile(payload) {
      const { data } = await api.put('/profile/', payload)
      this.user = data
    },
    /** Частичное обновление user (баланс, тариф и т.д.) без полного GET /profile/ */
    patchUser(partial) {
      if (!partial || typeof partial !== 'object') return
      if (!this.user) this.user = { ...partial }
      else this.user = { ...this.user, ...partial }
    },
    async applyAuthTokens(access, refresh) {
      localStorage.setItem('access', access)
      localStorage.setItem('refresh', refresh)
      this.access = access
      this.isAuth = true
      await this.fetchProfile()
      try {
        const syncResult = await syncUserKeys(api)
        const userId = resolveProfileUserId(this.user)
        applyKeySyncToStorage(userId, syncResult)
      } catch (syncErr) {
        console.warn('[auth] keys sync after token apply failed', syncErr)
      }
      router.replace(canUseProduct(this.user) ? '/search' : '/account')
    },
  },
})
